/* на весь экран: 60 % высоты за вычетом плашки «нет сети» (--offline-h) — кнопка повтора над плашкой (HQ-1659 v2).
   По бокам 12: Placeholder во всю строку с полями 12 (369 на 393, 336 на 360 — Figma 772:33139 / 1073:23619, HQ-2213) */
.center {
  min-height: calc(60vh - var(--offline-h, 0px)); display: flex; flex-direction: column; align-items: center; justify-content: center;
  gap: var(--space-2); padding: var(--space-6) var(--space-3); text-align: center;
}
/* внутри раздела (вкладка под шапкой и чипами): высота по содержимому — 60vh от середины экрана уводили кнопку под плашку */
.center.compact { min-height: 0; }
.skeleton { display: flex; flex-direction: column; gap: var(--space-3); padding: var(--space-3) var(--space-4); }
.skTabs {
  display: flex; gap: var(--space-4); align-items: center; height: 42px; padding: 0 var(--space-4);
  background: var(--surface); box-shadow: inset 0 -0.5px 0 var(--content-border);
}
.skTab { flex: 1 1 0; max-width: 72px; height: 14px; }
.skCard {
  background: var(--surface); border-radius: var(--radius-card); padding: var(--space-4);
  display: flex; flex-direction: column; gap: var(--space-3);
}
.skRow { display: flex; align-items: center; gap: var(--space-3); }
.skTitle, .skDot, .skLine, .skTail, .skTab {
  display: block; border-radius: 6px;
  background: linear-gradient(90deg, var(--content-border) 0%, var(--ground) 50%, var(--content-border) 100%);
  background-size: 200% 100%; animation: shimmer 1.4s ease-in-out infinite;
}
.skTitle { width: 40%; height: 14px; }
.skDot { width: 28px; height: 28px; border-radius: 50%; flex: none; }
.skLine { height: 12px; }
.skTail { width: 44px; height: 12px; margin-left: auto; flex: none; }
@keyframes shimmer { from { background-position: 100% 0; } to { background-position: -100% 0; } }
@media (prefers-reduced-motion: reduce) { .skTitle, .skDot, .skLine, .skTail, .skTab { animation: none; } }
.art { width: 128px; height: 128px; object-fit: contain; margin-bottom: var(--space-2); }
/* межстрочие в долях кегля (34/28, 22/17, 20/15): при крупном шрифте строки не ложатся друг на друга (HQ-1058 v2) */
/* Figma 28/500: «Oops, something went wrong» — одна строка на 393 (Roboto ≈ 354 из 361); уже 393 — кегль ужимается, а не перенос */
/* крупный шрифт (HQ-1183): ужатие по ширине сдвигается на прирост --fs-title сверх 28 — при 1× прежний min(28px, 7.2vw),
   при 2× (56) кегль растёт почти вдвое и на 360/320; перенос только по словам */
.title { font-size: min(var(--fs-title), calc(7.2vw + var(--fs-title) - 28px)); line-height: 1.215; font-weight: 500; letter-spacing: -0.4px;
  overflow-wrap: normal; word-break: normal; }
/* «не найдено» — одно слово (ta «கிடைக்கவில்லை» при ×2 ≈ 487 px шире 360/320, HQ-1552 v2): перенос внутри слова, без обрезки;
   у «Oops…» и «нет сети» (.title без модификатора) — по-прежнему только по словам */
.titleLong { overflow-wrap: anywhere; max-width: 100%; }
/* подпись — Figma Placeholder 772:33130 / 772:33139: 17/22, #212529@.52 = --content-secondary (HQ-1902; прежний --content-fine
   @.68 ради 4.5:1 из HQ-1321 снят: контраст вне MVP, цвета — из Figma, слово владельца 28.10) */
.text { font-size: var(--fs-body); line-height: 1.3; color: var(--content-secondary); max-width: 340px; }
.button {
  /* Figma ButtonText: 200×40, r12, 15/20 Medium; от текста — 16 (gap 8 + 8) */
  margin-top: var(--space-2); min-width: 200px; max-width: 100%; min-height: 40px; padding: 0 var(--space-4); border-radius: 12px;
  background: var(--accent); color: var(--on-accent); font-size: var(--fs-subheadline); line-height: 1.3333; font-weight: 500;
  letter-spacing: -0.4px;
}
